import { Component, Input, OnInit } from '@angular/core';
import { DetailsXMLSection } from 'src/app/model/section/details-xml-section';
import { TableSection } from 'src/app/model/shared/table-section';

import { documentToHtmlString } from '../table-section';

@Component({
  selector: 'app-definition-xml-section',
  templateUrl: './definition-xml-section.component.html',
  styleUrls: ['./definition-xml-section.component.scss']
})
export class DefinitionXmlSectionComponent implements OnInit {
  @Input() detailsXMLSections: DetailsXMLSection[] = [];
  @Input() tableSections: TableSection[] = [];
  @Input() iagPortalHowDoesItWork: boolean = false;
  data: any = [];

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }

  ngOnInit() {
    // console.log('detailsXMLSections', this.detailsXMLSections);
  }
}
